import * as React from 'react'
import { mkWidget, IOWidget } from 'widgets-for-react'

type SelectSettings = {
  className: string
  defaultEmptyOption?: boolean
}

type SelectOption = {
  value: string
  label: string
  selected?: boolean
}

const select: (_: SelectSettings) => IOWidget<SelectOption[], string> = ({
  className,
  defaultEmptyOption = true
}) => options =>
  mkWidget<string>({
    run: a => {
      if (defaultEmptyOption) {
        options = [{ value: '', label: 'Select a country' }, ...options]
      }
      return (
        <select onChange={e => a(e.target.value)} className={className}>
          {options.map(option => (
            <option value={option.value}>{option.label}</option>
          ))}
        </select>
      )
    }
  })

export { select }
